import { useMemo } from "react";
import styled from "styled-components";
import { freeTextContentCss } from "./freeTextStyle";
import { normalizeFreeTextHtml } from "./freeTextConfig";

interface Props {
  html?: string | null;
  // 본문 내 검색(EditorSearch)이 찾는 영역 id
  id?: string;
}

// FreeText 본문 열람 (읽기 전용)
// 편집기 인스턴스 대신 정리된 HTML 을 그려서, 본문 검색(mark.js)이 DOM 을 바꿔도 문제가 없다.
const FreeTextViewer = ({ html, id }: Props) => {
  const safeHtml = useMemo(() => normalizeFreeTextHtml(html), [html]);

  return <Content id={id} dangerouslySetInnerHTML={{ __html: safeHtml }} />;
};

const Content = styled.div`
  max-width: 100%;
  ${freeTextContentCss}
`;

export default FreeTextViewer;
